module.exports = __webpack_public_path__ + "img/sg.011a996d.svg";